import styles from "./SortControl.module.scss";

type SortDirection = "asc" | "desc" | null;

type SortControlProps = {
  direction: SortDirection;
  onChange?: (direction: SortDirection) => void;
};

const SortControl: React.FC<SortControlProps> = ({ direction, onChange }) => {
  const handleClick = () => {
    // Cycle through: null -> asc -> desc
    const nextDirection = !direction ? "asc" : direction === "asc" ? "desc" : null;
    onChange?.(nextDirection);
  };

  return (
    <div
      className={styles.container}
      onClick={handleClick}
      role="button"
      aria-label={`Sort ${direction || "none"}`}
      data-direction={direction}
    >
      <div className={styles.arrowContainer}>
        <div className={`${styles.arrowUp} ${direction === "asc" ? styles.active : ""}`} />
      </div>
      <div className={styles.arrowContainer}>
        <div className={`${styles.arrowDown} ${direction === "desc" ? styles.active : ""}`} />
      </div>
    </div>
  );
};

export default SortControl;
